(function ManageFolder($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		Adzuki.onload('BucketFolders/manage', function onload()
		{
			var folder_id = $('#bucketfolderedit-id').val();

			_renderBucketsInFolder(folder_id);
			_renderBucketsNotInFolder(folder_id);
		});
	});

	function _addBucketClickHandlers(folder_id)
	{
		$('.add-bucket').off().on('click', function _addBucket(e) {
			var bucket_id   = $(this).data('bucket-id');
			var $btn_parent = $(this).parent();

			e.preventDefault();

			Adzuki.Ajax.get('/BucketFolders/addBucketToFolder/' + folder_id + '/' + bucket_id)
			.then(function _addBucketToFolder(response) {
				if (response.error) {
					Adzuki.StatusMessage('error', 'Error adding your bucket: ' + response.error);
				}

				$btn_parent.fadeOut();

				_toastMessage('Bucket added to folder');
				_renderBucketsInFolder(folder_id);
				_renderBucketsNotInFolder(folder_id);
			});
		});
	}

	function _initTypeahead(folder_id)
	{
		Adzuki.Typeahead(
			$('.bucket-search'),
			function _source(term, display, $self) {
				var search_term = encodeURIComponent(term);

				Adzuki.Ajax.get('/BucketFolders/searchBucket/' + search_term + '/' + folder_id)
				.then(function _searchBucket(response) {
					$self.removeClass('ajax-spinner');
					display(response);
				});
			},
			function _onSelect(bucket, $self, typeahead) {
				$self.val('');

				Adzuki.Ajax.get('/BucketFolders/addBucketToFolder/' + folder_id + '/' + bucket.id)
				.then(function _addBucketToFolder(response) {
					if (response.error) {
						Adzuki.StatusMessage('error', 'Error adding your bucket: ' + response.error);
					}

					_toastMessage('Bucket added to folder');
					_renderBucketsInFolder(folder_id);
					_renderBucketsNotInFolder(folder_id);
				});
			}
		);
	}

	function _removeBucketClickHandlers(folder_id)
	{
		$('.remove-bucket').off().on('click', function _removeBucket(e) {
			var bucket_id   = $(this).data('bucket-id');
			var $btn_parent = $(this).parent();

			e.preventDefault();

			Adzuki.Ajax.get('/BucketFolders/removeBucketFromFolder/' + folder_id + '/' + bucket_id)
			.then(function _removeBucketFromFolder(response) {
				if (response.error) {
					Adzuki.StatusMessage('error', 'Error removing your bucket: ' + response.error);
				}

				$btn_parent.fadeOut();

				_toastMessage('Bucket removed from folder');
				_renderBucketsInFolder(folder_id);
				_renderBucketsNotInFolder(folder_id);
			});
		});
	}

	function _renderBucketsInFolder(folder_id)
	{
		Adzuki.Ajax.get('/BucketFolders/bucketsInFolder/' + folder_id)
		.then(function _bucketsInFolder(response) {
			$('.in-folder-content').html(response);

			_removeBucketClickHandlers(folder_id);
			_updateBucketCount(folder_id, true);
			_viewMoreClickHandlers();
		});
	}

	function _renderBucketsNotInFolder(folder_id)
	{
		Adzuki.Ajax.get('/BucketFolders/bucketsNotInFolder/' + folder_id)
		.then(function _bucketsNotInFolder(response) {
			$('.not-in-folder-content').html(response);

			_addBucketClickHandlers(folder_id);
			_updateBucketCount(folder_id, false);
			_viewMoreClickHandlers();
			_initTypeahead(folder_id);
		});
	}

	function _toastMessage(message)
	{
		toastr.success(
			null,
			message,
			{
				positionClass  : 'toast-top-center',
				timeOut        : 3000,
				extendedTimeOut: 0,
			}
		);
	}

	function _updateBucketCount(folder_id, in_folder)
	{
		var url        = '/BucketFolders/bucketsInFolder/' + folder_id + '/1';
		var class_name = 'buckets-in-count';

		if (!in_folder) {
			url        = '/BucketFolders/bucketsNotInFolder/' + folder_id + '/1';
			class_name = 'buckets-not-in-count';
		}

		Adzuki.Ajax.get(url)
		.then(function _bucketCount(response) {
			$('.' + class_name).html(response.count);
		});
	}

	function _viewMoreClickHandlers()
	{
		$('.view-more-buckets').off().on('click', function _onViewMoreClick(e) {
			var $self  = $(this);
			var amount = $self.data('amount');

			e.preventDefault();

			if ($self.data('state') === 'hidden') {
				// show the rest of the items
				$self.data('state', 'visible');
				$self.parents('.folder-content')
				.find('.bucket-row-past').removeClass('hidden');

				// update button text
				$self.find('i').first().removeClass('adzicon-plus fa-plus')
				.addClass('adzicon-collapse fa-minus-square');
				$self.find('span').first().html('View ' + amount + ' Less');
			} else {
				// hide the rest of the items
				$self.data('state', 'hidden');
				$self.parents('.folder-content')
				.find('.bucket-row-past').addClass('hidden');

				// update button text
				$self.find('i').first().removeClass('adzicon-collapse fa-minus-square')
				.addClass('adzicon-plus fa-plus');
				$self.find('span').first().html('View ' + amount + ' More');
			}
		});
	}
}(jQuery, window.Adzuki || {}));
